<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
    color?: string;
  }>(),
  {
    viewBox: '0 0 24 31',
    height: 31,
    width: 24,
    color: '#0F285B',
  }
);

const originalWidth = 24;
const originalHeight = 31;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="computedWidth"
    :height="computedHeight"
    :viewBox="props.viewBox"
    fill="none"
  >
    <path
      d="M20.5713 11.2286V3.32142C20.5713 1.48987 19.0334 0 17.1428 0C15.2522 0 13.7142 1.48987 13.7142 3.32142V6.84706C13.355 6.72308 12.974 6.64295 12.5714 6.64295C11.3539 6.64295 10.2895 7.2651 9.68076 8.19446C9.182 7.91983 8.61368 7.75009 7.99997 7.75009C6.78245 7.75009 5.7181 8.37224 5.10935 9.3016C4.61059 9.02697 4.04227 8.85723 3.42856 8.85723C1.53793 8.85723 0 10.3471 0 12.1787V16.6072C0 16.6213 0.00421625 16.6345 0.00421625 16.6486C0.0426574 21.0544 0.315475 24.2085 3.42865 27.0612V29.8929C3.42865 30.5043 3.9403 31 4.5715 31H19.4286C20.053 31 20.5619 30.5147 20.5714 29.9094C20.5977 28.2325 20.6987 26.1691 20.816 25.7598C20.9478 25.2981 21.5516 24.5921 22.0838 23.9689C23.1604 22.7082 24 21.7366 24 20.0724V15.4999C24 13.4425 22.5376 11.7236 20.5714 11.2284L20.5713 11.2286ZM15.9999 3.32142C15.9999 2.71102 16.5127 2.21428 17.1428 2.21428C17.7729 2.21428 18.2856 2.71102 18.2856 3.32142V11.0714H15.9999V3.32142ZM11.4285 9.96427C11.4285 9.35387 11.9413 8.85713 12.5714 8.85713C13.2015 8.85713 13.7142 9.35387 13.7142 9.96427V11.0714H11.4285V9.96427ZM6.85712 11.0714C6.85712 10.461 7.36988 9.96427 7.99997 9.96427C8.63006 9.96427 9.14282 10.461 9.14282 11.0714V15.5C9.14282 16.1104 8.63006 16.6071 7.99997 16.6071C7.36988 16.6071 6.85712 16.1104 6.85712 15.5V11.0714ZM2.28951 16.5985C2.28951 16.5923 2.28567 16.5867 2.28567 16.5804V12.1786C2.28567 11.5682 2.79843 11.0714 3.42852 11.0714C4.05862 11.0714 4.57138 11.5682 4.57138 12.1786V16.6071C4.57138 17.2175 4.05862 17.7143 3.42852 17.7143C2.80602 17.7143 2.30205 17.2282 2.28989 16.6278C2.28989 16.6178 2.28952 16.6086 2.28952 16.5986L2.28951 16.5985ZM21.7142 20.0725C21.7142 21.0191 21.1272 21.6162 20.3226 22.5569C19.611 23.3899 18.8758 24.2513 18.6129 25.1687C18.4316 25.8028 18.3485 27.5458 18.3112 28.7857L5.71443 28.7856V26.5713C5.71443 26.2517 5.57157 25.9476 5.32319 25.7372C3.42266 24.1305 2.68891 22.5354 2.42415 19.766C2.74383 19.862 3.07669 19.9285 3.42875 19.9285C4.64627 19.9285 5.71062 19.3063 6.31938 18.377C6.81813 18.6516 7.38645 18.8213 8.00016 18.8213C9.22647 18.8213 10.2958 18.1895 10.9018 17.2495C11.8073 18.0975 12.9864 18.6737 14.31 18.7959C13.1695 20.4318 12.5714 22.5752 12.5714 24.3571C12.5714 24.9686 13.0831 25.4642 13.7143 25.4642C14.3455 25.4642 14.8572 24.9686 14.8572 24.3571C14.8572 22.2816 15.9809 19.5149 17.6541 18.7048C18.1281 18.4749 18.3769 17.9598 18.2553 17.4597C18.1333 16.9604 17.6731 16.6072 17.1429 16.6072H14.8572C12.9665 16.6072 11.4286 15.1173 11.4286 13.2858H19.4286C20.6891 13.2858 21.7143 14.2789 21.7143 15.5001L21.7142 20.0725Z"
      :fill="props.color"
    />
  </svg>
</template>
